import React from "react";
import classnames from "classnames";
import { FmTag } from "@/ui-component";
import stl from "./title.module.scss";
import { IStyleProps } from "@/src/app/interface";
import {
    IInitedInfo,
    IProductDetailsInfo,
} from "@/store/modules/productDetails";
import MyFitTag from "@/src/components/MyFitTag";
import { useTranslation } from "@/src/i18n/client";

export interface IProps extends IStyleProps {
    productDetail: Partial<IInitedInfo & IProductDetailsInfo>;
}

const Title: React.FC<IProps> = (props) => {
    const { t } = useTranslation('productDetail');
    const NonRxPrescription = t("productDetail:NonRxPrescription");
    const { productDetail } = props;
    return (
        <div className={classnames(stl["title-line"])}>
            <div className={classnames("default_layout", stl["title-content"])}>
                <h5 className={classnames(stl["pro-modal-title"])}>{`#${
                    productDetail.products_description_relation
                        ?.products_name_attribute ||
                    productDetail.products_model
                }`}</h5>
                {/* 是否是儿童镜 */}
                {productDetail.is_kids && (
                    <div
                        className={classnames(stl["kids"], stl["prodct-icon"])}
                    >
                        <span>K</span>
                        <span>I</span>
                        <span>D</span>
                        <span>S</span>
                    </div>
                )}
                {/* 是否热卖 */}
                {productDetail.is_hot && (
                    <FmTag
                        backgroundColor="#E6A958"
                        style={{
                            marginLeft: "0.145rem",
                        }}
                    >
                        hot
                    </FmTag>
                )}
                {/* 是否新品 */}
                {productDetail.is_new && (
                    <FmTag
                        backgroundColor="#58B9E6"
                        style={{
                            marginLeft: "0.145rem",
                        }}
                    >
                        new
                    </FmTag>
                )}
                {productDetail.no_rx && (
                    <span className={classnames(stl["no-rx-icon"])}>
                        {NonRxPrescription}
                    </span>
                )}
                {productDetail.dimensions_lens &&
                    productDetail.dimensions_bridge && (
                        <MyFitTag
                            lensWidth={productDetail.dimensions_lens}
                            bridgeWidth={productDetail.dimensions_bridge}
                        />
                    )}
            </div>
        </div>
    );
};

export default Title;
